import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, map, filter } from 'rxjs/operators';
import { ProductService, UnitsResponse } from '@cemex-core/cmx-api';
import {
  OneClickOrdersActionTypes,
  OneClickSelectOrderAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import {
  OneClickUnitsActionTypes,
  OneClickLoadUnitsAction,
  OneClickLoadUnitsCompleteAction,
} from '../actions/one-click-units.actions';

@Injectable()
export class OneCLickAlternativeUnitsEffects {
  loadUnitsCommand = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickOrdersActionTypes.SELECT_ORDER),
      map((action: OneClickSelectOrderAction) => {
        return new OneClickLoadUnitsAction(action.payload);
      }),
    ),
  );

  getAlternativeUnits = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickUnitsActionTypes.LOAD_UNITS),
      map((action: OneClickLoadUnitsAction) => action.payload),
      filter((order) => !!order),
      switchMap((order) =>
        this.productService.getUnits(order.items[0].product.productId).pipe(
          map((response: UnitsResponse) => {
            return new OneClickLoadUnitsCompleteAction(response.productUnitConversions);
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private productService: ProductService,
  ) {}
}
